var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "cms-tool",
    class: {
      'pb-2 px-2': this.edit && _vm.type !== 'image'
    }
  }, [_c('div', {
    staticClass: "align-center tool-header d-flex flex-row"
  }, [_c('div', {
    staticClass: "align-center flex-row d-flex flex-grow-1 flex-shrink-1 text-truncate tool-label",
    on: {
      "click": _vm.highlightInPreview
    }
  }, [_c('v-icon', [_vm._v("mdi-drag-vertical")]), _c('v-icon', {
    staticClass: "ma-2 tool-icon"
  }, [_vm._v(_vm._s(this.icon))]), !this.edit ? _c('div', {
    staticClass: "align-center text-truncate flex-shrink-1 long-and-truncated"
  }, [_vm.type == 'product_image' ? _c('div', {
    staticClass: "text-header flex-shrink-1"
  }, [_vm._v(_vm._s(_vm.$t('cmstool_product_picture_auto')))]) : _vm.type == 'product_name' ? _c('div', {
    staticClass: "text-header flex-shrink-1"
  }, [_vm._v(_vm._s(_vm.$t('cmstool_product_name_auto')))]) : _vm.type == 'product_description' ? _c('div', {
    staticClass: "text-header flex-shrink-1"
  }, [_vm._v(_vm._s(_vm.$t('cmstool_product_description_auto')))]) : _vm.type == 'photo_auth' ? _c('div', {
    staticClass: "text-header flex-shrink-1"
  }, [_vm._v(_vm._s(_vm.$t('cmstool_authentication_app')))]) : _vm.type == 'scan_result' ? _c('div', {
    staticClass: "text-header flex-shrink-1"
  }, [_vm._v(_vm._s(_vm.$t('cmstool_authentication_result_auto')))]) : _vm.type == 'elabel' ? _c('div', {
    staticClass: "text-header flex-shrink-1"
  }, [_vm._v(_vm._s(_vm.$t('cmstool_elabel_button')))]) : _vm.type && _vm.type.startsWith('elabel_') ? _c('div', {
    staticClass: "text-header flex-shrink-1"
  }, [_vm._v(_vm._s(_vm.$t("cmstool_".concat(_vm.type))))]) : _vm.type == 'text' || _vm.type == 'consume' || _vm.type == 'large_text' || _vm.type == 'divider' ? _c('div', {
    staticClass: "text-header flex-shrink-1",
    domProps: {
      "innerHTML": _vm._s(_vm.getFirstLine(_vm.toolData.content[_vm.lang]))
    }
  }) : _vm.type == 'iframe' ? _c('div', {
    staticClass: "text-header flex-shrink-1"
  }, [_vm._v(_vm._s(_vm.toolData.url[_vm.lang]))]) : _vm.type == 'image' && !_vm.isDisplayableImage(_vm.toolData.src[_vm.lang]) ? _c('div', {
    staticClass: "text-header flex-shrink-1"
  }, [_vm._v(_vm._s(_vm.toolData.src[_vm.lang]))]) : _vm.type == 'image' && _vm.isDisplayableImage(_vm.toolData.src[_vm.lang]) ? _c('div', {
    staticClass: "text-header flex-shrink-1"
  }) : _vm.type == 'file' ? _c('div', {
    staticClass: "text-header flex-shrink-1"
  }, [_vm._v(_vm._s(_vm.fileToolLabel))]) : _c('div', {
    staticClass: "text-header flex-shrink-1"
  }, [_vm._v(_vm._s(_vm.toolData.content && _vm.toolData.content[_vm.lang] && _vm.toolData.content[_vm.lang].length ? _vm.toolData.content[_vm.lang] : _vm.$t('edit_me')) + " 👉")])]) : _vm._e(), (_vm.type == 'image' || _vm.type == 'gallery') && !this.edit && _vm.isDisplayableImage(_vm.toolData.src[_vm.lang]) ? _c('img', {
    staticClass: "image-header",
    attrs: {
      "src": _vm.toolData.src[_vm.lang]
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "tool-btn-ctn flex-shrink-0"
  }, [!this.edit ? _c('div', {
    staticClass: "d-flex flex-row"
  }, [_vm.type === 'product_name' || _vm.type === 'product_image' || _vm.type === 'product_description' || _vm.type === 'scan_result' || _vm.type && _vm.type.startsWith('elabel_') ? _c('div', [_vm.type === 'scan_result' ? _c('scan-result') : _vm._e()], 1) : _vm.type == 'gallery' ? _c('gallery-edit', {
    attrs: {
      "image": _vm.toolData.src[_vm.lang]
    },
    on: {
      "image-selected": _vm.onImageUpload
    }
  }) : _vm.type == 'image' ? _c('image-cropper', {
    attrs: {
      "input-key": "image-cropper-".concat(_vm.tabId, "-").concat(_vm.toolKey),
      "tab-id": _vm.tabId,
      "icon": true
    },
    on: {
      "image-upload": _vm.onImageUpload
    }
  }) : _c('v-btn', {
    attrs: {
      "color": "primary",
      "icon": ""
    },
    on: {
      "click": _vm.toggleEditMode
    }
  }, [_c('v-icon', [_vm._v("$edit")])], 1), _vm.type === 'image' && _vm.isAllowed('gallery_view') ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "primary"
          },
          on: {
            "click": _vm.handleSTGalleryBtnClick
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-image-outline")])], 1)];
      }
    }], null, false, 2560634782)
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('cmstool_select_image_gallery')))])]) : _vm._e(), _vm.type === 'file' && _vm.isAllowed('gallery_view') ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on,
          attrs = _ref2.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "primary"
          },
          on: {
            "click": _vm.handlePdfGalleryBtnClick
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-file-pdf-box")])], 1)];
      }
    }], null, false, 2633572480)
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('cmstool_select_pdf_gallery')))])]) : _vm._e(), _vm.type == 'image' && _vm.isAvailable('editor:tabs:tools:image:link') ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref3) {
        var on = _ref3.on,
          attrs = _ref3.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "primary",
            "icon": ""
          },
          on: {
            "click": _vm.toggleEditMode
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-link")])], 1)];
      }
    }], null, false, 1948808234)
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('cmstool_add_picture_with_link')))])]) : _vm._e(), _vm.type && _vm.type.startsWith('elabel_') && _vm.isAvailable('editor:tabs:tools:css') ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref4) {
        var on = _ref4.on;
        return [_c('v-btn', _vm._g({
          attrs: {
            "color": "accent",
            "icon": ""
          },
          on: {
            "click": function click($event) {
              return _vm.openStylesModal(true);
            }
          }
        }, on), [_c('v-icon', [_vm._v("mdi-code-json")])], 1)];
      }
    }], null, false, 3694762660)
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('css_editor')))])]) : _vm._e(), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.removeModal = true;
      }
    }
  }, [_c('v-icon', [_vm._v("$remove")])], 1)], 1) : _c('div', [_vm.type === 'file' && _vm.isAllowed('gallery_view') ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref5) {
        var on = _ref5.on,
          attrs = _ref5.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "primary"
          },
          on: {
            "click": _vm.handlePdfGalleryBtnClick
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-file-pdf-box")])], 1)];
      }
    }], null, false, 2633572480)
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('cmstool_select_pdf_gallery')))])]) : _vm._e(), _vm.isAvailable('editor:tabs:tools:css') ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref6) {
        var on = _ref6.on;
        return [_c('v-btn', _vm._g({
          attrs: {
            "color": "accent",
            "icon": ""
          },
          on: {
            "click": function click($event) {
              return _vm.openStylesModal();
            }
          }
        }, on), [_c('v-icon', [_vm._v("mdi-code-json")])], 1)];
      }
    }], null, false, 1740651346)
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('css_editor')))])]) : _vm._e(), _c('v-btn', {
    attrs: {
      "color": "accent",
      "icon": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_c('v-icon', [_vm._v("$check")])], 1), _c('v-btn', {
    attrs: {
      "color": "accent",
      "icon": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('v-icon', [_vm._v("$cancel")])], 1)], 1)])]), this.edit ? _c('div', {
    key: _vm.editBoxKey,
    staticClass: "edit-box"
  }, [_vm.type === 'text' && _vm.toolData.content ? _c('text-edit', {
    ref: "text-edit-".concat(_vm.toolKey, "-").concat(_vm.tabId),
    attrs: {
      "content": _vm.toolData.content[_vm.lang],
      "styles": _vm.toolStyles
    }
  }) : _vm._e(), _vm.type === 'large_text' && _vm.toolData.content ? _c('text-edit', {
    ref: "large-text-edit-".concat(_vm.toolKey, "-").concat(_vm.tabId),
    attrs: {
      "content": _vm.toolData.content[_vm.lang],
      "styles": _vm.toolStyles
    }
  }) : _vm._e(), _vm.type === 'photo_auth' ? _c('photo-auth-edit', {
    ref: "photo-auth-edit-".concat(_vm.toolKey, "-").concat(_vm.tabId),
    attrs: {
      "button": _vm.toolData.button[_vm.lang]
    }
  }) : _vm._e(), _vm.type == 'image' ? _c('image-edit', {
    ref: "image-edit-".concat(_vm.toolKey, "-").concat(_vm.tabId),
    attrs: {
      "src": _vm.toolData.src[_vm.lang]
    },
    on: {
      "update:src": function updateSrc($event) {
        return _vm.$set(_vm.toolData.src, _vm.lang, $event);
      }
    }
  }) : _vm._e(), _vm.type === 'button' && _vm.toolData.content ? _c('button-edit', {
    ref: "button-edit-".concat(_vm.toolKey, "-").concat(_vm.tabId),
    attrs: {
      "content": _vm.toolData.content[_vm.lang],
      "url": _vm.toolData.url[_vm.lang],
      "styles": _vm.toolStyles
    }
  }) : _vm._e(), _vm.type === 'file' && _vm.toolData.content ? _c('file-edit', {
    ref: "file-edit-".concat(_vm.toolKey, "-").concat(_vm.tabId),
    attrs: {
      "content": _vm.toolData.content[_vm.lang],
      "url": _vm.toolData.url[_vm.lang],
      "styles": _vm.toolStyles
    }
  }) : _vm._e(), _vm.type === 'divider' && _vm.toolData.content ? _c('divider-edit', {
    ref: "divider-edit-".concat(_vm.toolKey, "-").concat(_vm.tabId),
    attrs: {
      "content": _vm.toolData.content[_vm.lang],
      "styles": _vm.toolStyles
    }
  }) : _vm._e(), _vm.type === 'typeform' && _vm.toolData.content ? _c('typeform-edit', {
    ref: "typeform-edit-".concat(_vm.toolKey, "-").concat(_vm.tabId),
    attrs: {
      "content": _vm.toolData.content[_vm.lang],
      "mode": _vm.toolData.mode,
      "url": _vm.toolData.url[_vm.lang],
      "styles": _vm.toolStyles
    }
  }) : _vm._e(), _vm.type === 'social' && _vm.toolData.content ? _c('social-edit', {
    ref: "social-edit-".concat(_vm.toolKey, "-").concat(_vm.tabId),
    attrs: {
      "content": _vm.toolData.content[_vm.lang],
      "url": _vm.toolData.url[_vm.lang],
      "icon": _vm.toolData.icon,
      "styles": _vm.toolStyles
    }
  }) : _vm._e(), _vm.type === 'video' && _vm.toolData.content ? _c('video-edit', {
    ref: "video-edit-".concat(_vm.toolKey, "-").concat(_vm.tabId),
    attrs: {
      "content": _vm.toolData.content[_vm.lang]
    },
    on: {
      "update:content": function updateContent($event) {
        return _vm.$set(_vm.toolData.content, _vm.lang, $event);
      }
    }
  }) : _vm._e(), _vm.type === 'iframe' ? _c('iframe-edit', {
    attrs: {
      "url": _vm.toolData.url[_vm.lang],
      "height": _vm.toolData.height[_vm.lang]
    },
    on: {
      "update:url": function updateUrl($event) {
        return _vm.$set(_vm.toolData.url, _vm.lang, $event);
      },
      "update:height": function updateHeight($event) {
        return _vm.$set(_vm.toolData.height, _vm.lang, $event);
      }
    }
  }) : _vm._e(), _vm.type === 'consume' ? _c('consume-edit', {
    ref: "consume-edit-".concat(_vm.toolKey, "-").concat(_vm.tabId),
    attrs: {
      "content": _vm.toolData.content[_vm.lang],
      "consumed": _vm.toolData.consumed[_vm.lang],
      "button": _vm.toolData.button[_vm.lang],
      "mode": _vm.toolData.mode,
      "styles": _vm.toolStyles
    },
    on: {
      "update:content": function updateContent($event) {
        return _vm.$set(_vm.toolData.content, _vm.lang, $event);
      },
      "update:consumed": function updateConsumed($event) {
        return _vm.$set(_vm.toolData.consumed, _vm.lang, $event);
      },
      "update:button": function updateButton($event) {
        return _vm.$set(_vm.toolData.button, _vm.lang, $event);
      },
      "update:mode": function updateMode($event) {
        return _vm.$set(_vm.toolData, "mode", $event);
      }
    }
  }) : _vm._e(), _vm.type === 'elabel' && _vm.toolData.content ? _c('elabel-edit', {
    ref: "elabel-edit-".concat(_vm.toolKey, "-").concat(_vm.tabId),
    attrs: {
      "content": _vm.toolData.content[_vm.lang],
      "styles": _vm.toolStyles
    },
    on: {
      "update:content": function updateContent($event) {
        return _vm.$set(_vm.toolData.content, _vm.lang, $event);
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: _vm.stylesModal,
      callback: function callback($$v) {
        _vm.stylesModal = $$v;
      },
      expression: "stylesModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('cmstool_update_widget_css')))]), _c('vue-json-editor', {
    ref: "jsonEditor",
    staticClass: "fullscreen",
    attrs: {
      "mode": "code",
      "expandedOnStart": true
    },
    model: {
      value: _vm.toolStyles,
      callback: function callback($$v) {
        _vm.toolStyles = $$v;
      },
      expression: "toolStyles"
    }
  }), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.cancelStylesModal
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))]), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.updateStyle
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: _vm.removeModal,
      callback: function callback($$v) {
        _vm.removeModal = $$v;
      },
      expression: "removeModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('delete_confirmation')))]), _c('v-card-text', [_c('div', {
    staticClass: "my-5"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('cmstool_remove_item_question')))])])]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.removeModal = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))]), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "red"
    },
    on: {
      "click": _vm.remove
    }
  }, [_vm._v(_vm._s(_vm.$t('remove')))])], 1)], 1)], 1), _c('select-image-dialog', {
    attrs: {
      "display-select-image-dialog": _vm.displaySTGalleryDialog,
      "app-tags": ['stc-editor-image'],
      "isAllowedEdit": _vm.isAllowed('gallery_edit')
    },
    on: {
      "update:displaySelectImageDialog": _vm.closeSTGalleryDialog,
      "gallery-selected": _vm.handleSTGallerySelected
    }
  }), _c('select-image-dialog', {
    attrs: {
      "file-type": "pdf",
      "display-select-image-dialog": _vm.displayPdfGalleryDialog,
      "isAllowedEdit": _vm.isAllowed('gallery_edit')
    },
    on: {
      "update:displaySelectImageDialog": _vm.closePdfGalleryDialog,
      "gallery-selected": _vm.handlePdfGallerySelected,
      "gallery-item-selected": _vm.handlePdfGalleryItemSelected
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }